module.exports = __webpack_public_path__ + "static/media/SF UI Display Bold.6f1c9640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Bold.svg
// module id = 219
// module chunks = 0